var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createContext, useContext, useMemo, useRef, useState, } from "react";
import { ModalProvider } from "./ModalContext";
import { ExitModalProvider } from "./ExitModalContext";
var RouterContext = createContext(undefined);
export var RouterProvider = function (_a) {
    var _b = _a.initialRoute, initialRoute = _b === void 0 ? "home" : _b, _c = _a.initialParams, initialParams = _c === void 0 ? {} : _c, children = _a.children;
    var _d = useState({
        route: initialRoute,
        params: initialParams,
    }), nav = _d[0], setNav = _d[1];
    var historyRef = useRef([]);
    var maxHistory = 30;
    var isSameParams = function (a, b) {
        return Object.keys(a).length === Object.keys(b).length &&
            Object.keys(a).every(function (key) { return a[key] === b[key]; });
    };
    var clearConsoleBox = function () {
        if (window.clearConsoleBox) {
            window.clearConsoleBox();
        }
    };
    var navigate = function (nextRoute, nextParams) {
        if (nextParams === void 0) { nextParams = {}; }
        clearConsoleBox();
        var last = historyRef.current[historyRef.current.length - 1];
        var isDuplicate = last && last.route === nav.route && isSameParams(last.params, nav.params);
        if (!["auth", "profiles", "watch"].includes(nav.route) && !isDuplicate) {
            historyRef.current.push({
                route: nav.route,
                params: __assign({}, nav.params),
            });
            if (historyRef.current.length > maxHistory) {
                historyRef.current.shift();
            }
        }
        setNav({
            route: nextRoute,
            params: nextParams,
        });
    };
    var goBack = function () {
        var prev = historyRef.current.pop();
        if (!prev)
            return;
        clearConsoleBox();
        setNav({
            route: prev.route,
            params: prev.params,
        });
    };
    var value = useMemo(function () { return ({
        route: nav.route,
        params: nav.params,
        navigate: navigate,
        goBack: goBack,
    }); }, [nav]);
    return (React.createElement(RouterContext.Provider, { value: value },
        React.createElement(ModalProvider, null,
            React.createElement(ExitModalProvider, null, children))));
};
export var useRouter = function () {
    var context = useContext(RouterContext);
    if (!context) {
        throw new Error("useRouter must be used within a RouterProvider");
    }
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./src/context/Router.tsx
// module id = 4
// module chunks = 1